<template>
  <v-container fluid class="px-1 py-1 my-0">
    <CommonCardList
        title="MaterialDelivery"
        :height="height"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail"
        :parent-component="$options.name"
        :main-validator="true"
        :vertical-grid="{xs: 12, sm: 12, md: 12, lg: 12, xl: 12,}"
        :horizontal-grid="{xs: 12, sm: 12, md: 12, lg: 12, xl: 12,}"
    >
      <template v-slot:bar>{{ '' }}</template>
      <template v-slot:footer.prepend>{{ '' }}</template>
      <template v-slot:card="{item}">
        <v-card class="mt-3" :color="item.item_color">
          <v-system-bar height="24" class="px-0"
                        :color="selectedMaterialDelivery(item.uid) ? 'orange lighten-3' : null">
            <v-chip small outlined>{{ $t('edited_by') }}: {{
                storeAggregate.rootData[item.edited_by_uid].username
              }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-chip small outlined>{{ $t('edited_on') }}: {{ item.edited_on | moment("DD.MM.YY HH:mm") }}</v-chip>
          </v-system-bar>
          <v-sheet class="mx-3 my-3" :color="item.item_color">
            <v-row>
              <v-col cols="3" v-if="item.opened === true">
                <v-row>
                  <v-btn
                      height="65"
                      @click="$emit('select', item.uid)"
                      :color="selectedMaterialDelivery(item.uid) ? 'orange lighten-3' : item.item_color"
                      class="mx-3 my-3"
                  >{{ $t('select') }}
                  </v-btn>
                </v-row>
                <v-row>
                  <v-checkbox
                      v-model="item.mandatory_pn"
                      :label="$t('mandatory_pn')"
                      class="mx-3"
                      readonly
                  ></v-checkbox>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <BaseFieldString
                        v-model="item.delivery_number"
                        :label="$t('delivery_number')"
                        readonly
                    >
                    </BaseFieldString>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <BaseFieldString
                        v-if="!!item.provider_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.provider_uid]"
                        v-model="storeAggregate.rootData[item.provider_uid].name"
                        :label="$t('provider')"
                        readonly
                    >
                    </BaseFieldString>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <BaseFieldString
                        v-if="!!item.material_owner_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.material_owner_uid]"
                        v-model="storeAggregate.rootData[item.material_owner_uid].name"
                        :label="$t('material_owner')"
                        readonly
                    >
                    </BaseFieldString>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <BaseFieldString
                        v-if="!!item.usage_restriction_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.usage_restriction_uid]"
                        v-model="storeAggregate.rootData[item.usage_restriction_uid].name"
                        :label="$t('usage_restriction')"
                        readonly
                    >
                    </BaseFieldString>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card>
      </template>
    </CommonCardList>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useCardListStore} from "@/components/Common/CommonCardList";
import CommonTable from "@/components/Common/CommonTable";
import MaterialDeliveryDetail from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CommonCardList from "@/components/Common/CommonCardList";
import BaseFieldString from "@/components/Base/BaseFieldString";

export default {
  name: "MaterialDeliveryCardList",

  props: {
    height: {default: null},
    embedded: {default: false},
    storeName: {type: [String], default: 'MaterialDeliveryTable'},
    dtoDetailQuery: {default: 'MaterialDeliveryDetailQueryDTO'},
    detailStoreName: {default: 'MaterialDeliveryDetail'},
    dtoValidateCommand: {type: [String], default: 'MaterialDeliveryValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialDeliveryListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialDeliveryActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    selectedMaterialDelivery: {
      type: [Function], default(uid) {
        return null
      }
    },
  },

  components: {
    BaseFieldString,
    CommonTable,
    MaterialDeliveryDetail,
    BaseFieldCheck,
    CommonCardList,
  },

  methods: {},


  mounted() {
    this.storeCardList = useCardListStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    if (!!this.storeCardList) {
      this.storeCardList.dtoDetailQuery = this.dtoDetailQuery
      this.storeCardList.dtoListQuery = this.dtoListQuery
      this.storeCardList.dtoActionCommand = this.dtoActionCommand
      this.storeCardList.options.sortBy = ['edited_on']
    }
  },

  data() {
    return {
      storeAggregate: null,
      storeCardList: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>